(function ($) {
    $.YPTC = $.YPTC || {};
    $.YPTC.Delta = $.YPTC.Delta || {};
    $.YPTC.Delta.Report = $.YPTC.Delta.Report || {};
    $.YPTC.Delta.Report.EditColumnSubtotal = $.YPTC.Delta.Report.EditColumnSubtotal || (function () {
        var 
        _report_id = null,

        init = function (reportID) {
            _report_id = reportID;

            // Setup click handlers
            setupAdd();
            setupEdit();
        },


        //
        // add subtotol column button in dropdown menu
        //
        setupAdd = function() {
            // add SubTotal column
            $(document).on('click', '.column-add-subtotal', function() {
                var $addButton = $(this).closest('.dropdown-menu').prev('.column-add-a');
                var $spinner = $("#column-add-image-loading");

                showModal($addButton, $spinner, true, null, null);

                return false;
            });
        },

        
        //
        // edit subtotal button
        //
        setupEdit = function() {
            $(document).on('click', '.column-edit-subtotal', function() {
                var $addButton = $(this);
                var $spinner = $(this).siblings('.column-map-spinner');
                var columnID = $addButton.attr('data-column-id');
                var columnName = $addButton.attr('data-column-name');

                showModal($addButton, $spinner, false, columnID, columnName);

                return false;
            });
        },




        //
        // add subtotal column popup, columnID & columnName will be null if isNew = true
        //
        showModal = function($addButton, $spinner, isNew, columnID, columnName) {
            //hide the add button & show the spinner
            $addButton.hide();
            $spinner.show();

            //call the controller & get the popup
            delta.ajax.get(
                `/report/ColumnSubtotal?reportID=${_report_id}&columnID=${columnID}`,
                function (html) {
                    delta.popup.open({
                        type: 'confirm',
                        title: `${isNew ? 'Add' : 'Edit'} Subtotal Column`,
                        content: html,
                        cssClass: 'modal-lg',
                        afterOpen: function ($popup) {
                            //hide the spinner & restor the Add button
                            $spinner.hide();
                            $addButton.show();

                            setupModal($popup, isNew, columnName);
                        },
                        cancelCallback: function () {
                            // Restore UI elements
                            $spinner.hide();
                            $addButton.show();
                        },
                        closeCallback: function () {
                            // Restore UI elements
                            $spinner.hide();
                            $addButton.show();
                        },
                        okCallback: function ($popup) {
                            // Show spinner & disable the ok button
                            showSpinner($popup);
                            
                            var formData = new FormData();
                            $popup.find('form').find('input').each(function() {
                                var $elem = $(this);
                                var name = $elem.attr('name');
                                var type = $elem.attr('type');
                                var value = $elem.val();
                                if (type == 'checkbox' || type == "radio") {
                                    if ($elem.is(':checked')) {
                                        formData.append(name, value);
                                    } 
                                } else {
                                    formData.append(name, value);
                                }
                            });

                            //now add the positions
                            $popup.find('.column-position-item').each(function() {
                                formData.append("ColumnPositions", $(this).attr('data-column-id'));
                            });

                            delta.ajax.postFormData(
                                '/report/ColumnSubtotal', 
                                formData, 
                                function (result) {
                                    if (result.ok) location.reload();
                                    else {
                                        hideSpinner($popup);
                                        console.log(result);
                                    }
                                }
                            );

                            return false; //keep it open
                        }
                    });
                },
                function (error) {
                    // Handle AJAX error
                    console.error("Error loading add dimension form:", error);

                    // Restore UI elements
                    $addButton.css('visibility', 'visible');
                    $spinner.hide();
                }
            );

        };


        //
        // setup the edit column popup after it's open
        //
        setupModal = function($popup, isNew, columnName) {
            //get the popup body
            var $body = $popup.find('.modal-body');

            //get the column name (label) elem, & column id
            var $label = $body.find("#ColumnName");
            var columnID = $body.find('#ColumnID').val();

            //add delete button
            if (!isNew) {
                $popup.find('.modal-footer').prepend(
                    `<button type="button" class="btn btn-danger delete-column-btn float-start">Delete</button>`
                );

                //delete button handler
                $popup.on('click', '.delete-column-btn', function() {
                    showDeleteConfirmation(columnID, columnName);
                });

            }

            // Set up sortable for position tab with a filter for the total column
            $body.find("#column-position-sortable").sortable({
                axis: "x",
                containment: "parent",
                items: "li:not(.non-sortable)", // Prevent total column from being sorted
                update: function (event, ui) {
                    // Always ensure Total column is last after any sorting operation
                    var $totalCol = $body.find('#column-position-sortable li.non-sortable');
                    if ($totalCol.length > 0) {
                        $body.find("#column-position-sortable").append($totalCol);
                    }
                }
            });

            //validation function
            function validateSubtotalLabel() {
                if ($label.val()) {
                    $label.removeClass('is-invalid');
                } else {
                    $label.addClass('is-invalid');
                }
            }
            validateSubtotalLabel();

            // Update column name in position tab when user types in the label field
            $label.off('input').on("input", function () {
                $body.find(`li[data-column-id='${columnID}'] h6.position-column-name`).text($label.val());
                validateSubtotalLabel();
            });


            // scroll to show our new position item
            $('#nav-position-tab').off('shown.bs.tab').on('shown.bs.tab', function (e) {
                var $li = $body.find('.column-position-item[data-column-id="' + columnID + '"]');
                $li[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            });
        },

        
        //
        // show the delete confirmation
        //
        showDeleteConfirmation = function (columnID, columnName) {
            // Create confirmation dialog
            delta.popup.open({
                type: 'confirm',
                title: 'Delete Column',
                cssClass: 'column-delete-popup',
                content: `Are you sure you want to delete the column "<b>${columnName}</b>"?`,
                okButtonText: 'Yes, Delete',
                afterOpen: function ($popup) {
                    $popup.find('.modal-footer .btn-primary')
                        .removeClass('btn-primary')
                        .addClass('btn-danger');
                },
                okCallback: function ($popup) {
                    //show spinner & disable buttons
                    showSpinner($popup);

                    //call controller to delete it
                    delta.ajax.get(
                        `/report/columnSubtotalDelete?reportID=${_report_id}&columnID=${columnID}`,
                        function() {
                            //reload the page
                            location.reload();
                        }                        
                    )

                    return false;
                }
            });
        },


        //
        // show the spinner & disable the buttons
        //
        showSpinner = function ($popup) {
            $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
            $popup.find('.modal-footer button').prop('disabled', true);
        },

        //
        // hide the spinner & enable buttons
        //
        hideSpinner = function ($popup) {
            var spinner = $popup.find('.modal-footer .fa-spinner');
            if (spinner.length > 0) {
                spinner.remove();
            }

            // Re-enable buttons
            $popup.find('.modal-footer button').prop('disabled', false);
        },
        
        dummy = function() {};


        // Public API
        return {
            Init: init
        };
    })();
})(jQuery);